import { put } from '../util/secure_fetch.js';

const DESKTOP_FONT_SELECTIONS_ENDPOINT = '/desktop_font_selections';

export async function syncVariations(variationIds) {
  return put(DESKTOP_FONT_SELECTIONS_ENDPOINT, {
    body: formatBody({ add_font_ids: variationIds })
  });
}

export async function unsyncVariations(variationIds) {
  return put(DESKTOP_FONT_SELECTIONS_ENDPOINT, {
    body: formatBody({ remove_font_ids: variationIds })
  });
}

/**
 * Format the request body for the desktop font selections API
 *
 * The double JSON.stringify is intentional, because this is how the
 * existing API expects the data.
 *
 * Once all of the existing Angular based syncing code has been replaced
 * we should be able to revisit this and get rid of the double stringify.
 *
 * @param {String[]} variationIds
 * @returns {String}
 */
function formatBody(data) {
  return JSON.stringify({
    data: JSON.stringify(data)
  });
}
